import { createContext, useEffect, useState } from "react";
import { SignatureCanvas } from "./signature.hook";
// import { SignatureCanvas } from "./signature.hook";
import "./style.css"
import useQuery from "hooks/useQuery.hook";


export const SignatureContext = createContext<any>({
  el: null,
  ctx: null,
});

export default function Signature() {
  const [type, setType] = useState<string>("agree");
  const [context, setContext] = useState<any>(null);
  const query = useQuery();
  useEffect(() => {
    const dom = document.getElementById("signature") as HTMLCanvasElement;
    const signature = new SignatureCanvas(dom, {
      waterFlag: {
        name: query.name,
      }
    });
    setContext(signature);
    setType(query.type as any || "agree");
    return () => {
      signature.destroy();
    };
  }, [query.name, query.type]);
  const clearCanvas = () => context.clear();

  const [loading, setLoading] = useState<boolean>(false);

  const onClickSubmit = async () => {
    if(loading) return;
    setLoading(true);
    window.ReactNativeWebView &&
            window.ReactNativeWebView.postMessage("img-uploading");
    const img = context.generateImage();
    window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify(img));
    setTimeout(() => {
      setLoading(false);
    },300)
    window.ReactNativeWebView &&
            window.ReactNativeWebView.postMessage("img-finished");
  };

  return (
    <div
      className='signature-container'
    >
      <div className="operator">
        <div className="left">
        </div>
        <div
          className="btn btn-default"
          style={{ marginRight: "10px" }}
          onClick={clearCanvas}
        >
          重写
        </div>
        {type === "agree" && (
          <div
            className="btn btn-timon"
            style={{ marginRight: "10px" }}
            onClick={onClickSubmit}
          >
            提交
          </div>
        )}
        {type === "photo" && (
          <div
            className="btn btn-timon"
            style={{ width: "180px", marginRight: "10px" }}
            onClick={onClickSubmit}
          >
            自拍确认为本人签名
          </div>
        )}
        <div style={{ width: '20px' }}></div>
      </div>
      <div style={{ display: 'flex'}}> 
        <div style={{width: 70 }}></div>
      <canvas id="signature"></canvas>
      </div>
    </div>
  );
}
